import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import Article1 from '@/pages/Article1'
import Article2 from '@/pages/Article2'
import Article3 from '@/pages/Article3'
import Article4 from '@/pages/Article4'
import Article5 from '@/pages/Article5'
import Article6 from '@/pages/Article6'
import Article7 from '@/pages/Article7'
import Article8 from '@/pages/Article8'

Vue.use(Router)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/kto-est-kto-v-mire-hodyachih-mertvecov',
		name: 'kto-est-kto-v-mire-hodyachih-mertvecov',
		component: Article1
	},
	{
		path: '/chto-delat-esli-vas-ukusili',
		name: 'chto-delat-esli-vas-ukusili',
		component: Article2
	},
	{
		path: '/pamyati-pavshih',
		name: 'pamyati-pavshih',
		component: Article3
	},
	{
		path: '/otkuda-poyavilsya-virus',
		name: 'otkuda-poyavilsya-virus',
		component: Article4
	},
	{
		path: '/golova-s-plech',
		name: 'golova-s-plech',
		component: Article5
	},
	{
		path: '/100-epizodov-hodyachih',
		name: '100-epizodov-hodyachih',
		component: Article6
	},
	{
		path: '/vse-zlo-ot-lyudei',
		name: 'vse-zlo-ot-lyudei',
		component: Article7
	},
	{
		path: '/zdes-vam-radi',
		name: 'zdes-vam-radi',
		component: Article8
	},
]

export default new Router({
	routes,
	mode: 'history',
	scrollBehavior() {
		return { x: 0, y: 0 }
	}
})



// WEBPACK FOOTER //
// ./src/router.js